import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10d85f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 col-md-12" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = { class: "col-12 col-md-12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Rate Card", -1))
const _hoisted_9 = { class: "row mt-4" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Rate Perdetik ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan waktu berita dan cakupan dari media`
}, null, -1))
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" AD Value ")
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "col-12 col-md-12" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")
const _hoisted_20 = { class: "col-12 col-md-12" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" File Berita ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex text-primary",
  style: {"margin-top":"10px","font-size":"11px"}
}, " Maksimal Ukuran: 50 MB, Ekstensi: mp4. ", -1))
const _hoisted_23 = { class: "d-flex flex-nowrap gap-3" }
const _hoisted_24 = { class: "border border-1 border-primary border-dashed rounded w-20 h-25" }
const _hoisted_25 = { class: "custom-thumbnail" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "custom-actions" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search text-primary fs-4" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger fs-4" }, null, -1))
const _hoisted_30 = { class: "custom-thumbnail" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "custom-actions" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search text-primary fs-4" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger fs-4" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload text-white" }, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_37 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_38 = ["src"]

import { IMedkon } from "@/global-helper/data-structure";
import { ref, watch } from 'vue';
import ApiService from "@/core/services/ApiService";
import { ElMessageBox } from "element-plus";
import JwtService from "@/core/services/JwtService";

interface IProps{
  form: IMedkon;
  type: string;
  refreshupload: boolean;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    form: { type: null, required: true },
    type: { type: String, required: true },
    refreshupload: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
  form: IMedkon;
  type: string;
  refreshupload: boolean;
}
;


const loading = ref(false);
const actionFileURL = `${process.env.VUE_APP_API_URL}/streams/uploadfile`;
const file_upload_header = ref({
  Authorization: `Bearer ${JwtService.getToken()}`,
});
const dialogPreviewFile = ref(false);
const dialogFileUrl = ref('');

const media_options = ref([]);
const stasiun_options = ref([])
const sentiment_options = ref([
  { value: null, label: "Tidak Ada", icon: "" },
  { value: 1, label: "Positif", icon: "far fa-smile fs-2x text-success" },
  { value: 0, label: "Netral", icon: "far fa-meh text-primary fs-2x" },
  { value: -1, label: "Negatif", icon: "far fa-frown text-danger fs-2x" },
])

const form = ref<IMedkon>(props.form);
const type = ref(props.type)
const uploadRef = ref(null);
const render_upload = ref(true);

const remoteMethod = (query) => {
  if (query.length > 2) {
    loading.value = true;
    let url = `/media-tv/stasiun?stasiun=${query}&limit=100&page=1`;

    ApiService.get(url)
      .then((response) => {
        media_options.value = response.data.data;
        return media_options.value;
      })
      .catch((error) => {
        loading.value = false;
      })
      .finally(() => {
        loading.value = false;
      });
    return [];
  } else {
    media_options.value = [];
  }
};

const checkADValueFromDuration = () => {
  form.value.ad_value = 0;
  form.value.rate_perdetik = 0;
  form.value.ppn = 0;

  if (
    form.value.account &&
    form.value.date &&
    form.value.duration
  ) {
    ApiService.post("/streams/rumus-ad-value", {
      data: {
        nama_media: form.value.account,
        publish_date: form.value.date,
        durasi_video: form.value.duration || 0,
      },
    })
      .then((res) => {
        form.value.ad_value = res.data.ad_value || 0;
        form.value.rate_perdetik = res.data.rate_per_detik || 0;
        form.value.ppn = res.data.ppn || 0;
      })
      .catch(() => {
        form.value.ad_value = 0;
        form.value.rate_perdetik = 0;
        form.value.ppn = 0;
      });
  }
};

const setFileUpload = (response, file, fileList) => {
  const list_file: any = []

  fileList.forEach(element => {
    list_file.push(element.response.file);
  });

  form.value.file_source.new = list_file;
};

const cekFileSource = (file, fileList) => {
  if (fileList.length == 0) {
    form.value.file_source.new = [];
  } else {
    const list_file: any = []

    fileList.forEach(element => {
      list_file.push(element.response.file);
    });

    form.value.file_source.new = list_file;
  }
};

const removeFileUpload = (file, type) => {
  let file_to_remove = '';

  if (type == 'old') {
    file_to_remove = file;
  } else {
    file_to_remove = file.response.file;
  }

  ApiService.post("/streams/removefile", { data: { path: file_to_remove } })
    .then((response) => {
      ElMessageBox.alert("Hapus File", 'File berhasil dihapus.', {
        confirmButtonText: "OK",
        type: "success",
        center: true,
      });
    })
    .catch((error) => {
      ElMessageBox.alert("Hapus File", 'File gagal dihapus.', {
        confirmButtonText: "OK",
        type: "warning",
        center: true,
      });
    });
};

const errorFileUpload = (error, file, fileList) => {
  let message = JSON.parse(error.message);
  ElMessageBox.alert("Silakan periksa inputan Anda.", message.detail, {
    confirmButtonText: "OK",
    type: "warning",
    center: true,
  });
};

const handlePreview = (type, file) => {
  if (type == 'new') {
    dialogFileUrl.value = file.url || URL.createObjectURL(file.raw);
    dialogPreviewFile.value = true;
  } else {
    dialogFileUrl.value = file;
    dialogPreviewFile.value = true;
  }
};

const handleDelete = (type, file) => {
  if (type == 'new') {
    uploadRef.value?.handleRemove(file);
  } else {
    form.value.file_source.old = form.value.file_source.old.filter(item => item !== file)
    removeFileUpload(file, 'old');
  }
};

const convertText = () => {
  if (form.value.content != null) {
    let text = form.value.content.split("\n\n");
    let newText = "";

    for (let i = 0; i < text.length; i++) {
      let perTextArray = text[i].split("\n");
      for (let j = 0; j < perTextArray.length; j++) {
        if (perTextArray[j].charAt(perTextArray[j].length - 1) == "-") {
          newText += perTextArray[j].replace(/-/g, "");
        } else {
          newText += perTextArray[j] + " ";
        }
      }
      newText += "\n";
    }
    form.value.content = newText;
  }
};

watch(props, () => {
  if(props.refreshupload){
    render_upload.value = false;

    setTimeout(() => {
      render_upload.value = true;
      props.refreshupload = false;
    }, 200);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form_item, {
        label: "Judul Berita",
        prop: "title",
        rules: {
        required: true,
        message: 'Judul Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            placeholder: "Judul Berita",
            modelValue: form.value.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
            rows: "2",
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (form.value.title = form.value.title.trim()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form_item, {
        label: "Nama Stasiun TV",
        prop: "account",
        rules: {
        required: true,
        message: 'Nama Stasiun TV Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Nama Stasiun TV",
            "allow-create": media_options.value.length == 0,
            name: "account",
            modelValue: form.value.account,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.account) = $event)),
            "reserve-keyword": "",
            loading: loading.value,
            "remote-method": remoteMethod,
            autocomplete: "off",
            remote: true,
            class: "d-block",
            onChange: checkADValueFromDuration
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(media_options.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item._id,
                  value: item._id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["allow-create", "modelValue", "loading"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form_item, {
        label: "Tanggal Berita",
        prop: "date",
        rules: {
        required: true,
        message: 'Tanggal Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            style: {"width":"100% !important"},
            modelValue: form.value.date,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.date) = $event)),
            placeholder: "Tanggal Berita",
            format: "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            name: "date",
            type: "datetime",
            onChange: checkADValueFromDuration
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form_item, {
        label: "Jurnalis",
        prop: "journalist",
        rules: {
        required: false,
        message: 'Jurnalis Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: form.value.journalist,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.journalist) = $event)),
            placeholder: "Jurnalis",
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (form.value.journalist = form.value.journalist.trim()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form_item, {
        label: "Sentimen",
        prop: "sentiment",
        rules: {
        required: false,
        message: 'Sentimen Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            class: "form-control-custom",
            modelValue: form.value.sentiment,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.sentiment) = $event)),
            placeholder: "Sentimen"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentiment_options.value, (options) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: options.value,
                  label: options.label,
                  value: options.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, [
                      _createElementVNode("i", {
                        class: _normalizeClass(options.icon)
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(options.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_form_item, {
            label: "Durasi Video (Detik)",
            prop: "duration",
            rules: {
            required: true,
            message: 'Kolom Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.duration,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((form.value.duration) = $event)),
                  checkADValueFromDuration
                ],
                placeholder: "Durasi"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form_item, {
            prop: "rate_perdetik",
            rules: {
            required: false,
            message: 'Lebar Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.rate_perdetik,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.rate_perdetik) = $event)),
                placeholder: "Rate Perdetik",
                disabled: "true"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_form_item, {
            prop: "ad_value",
            rules: {
            required: false,
            message: 'AD Value Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_15,
              _createElementVNode("i", {
                class: "fas fa-exclamation-circle ms-2 fs-7",
                "data-bs-toggle": "tooltip",
                "data-bs-placement": "top",
                title: `Durasi video * Rate per detik dan nilai sudah termasuk PPN ${form.value.ppn > 0 ? form.value.ppn+'%' : '' }`
              }, null, 8, _hoisted_16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.ad_value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.ad_value) = $event)),
                placeholder: "AD Value"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_form_item, {
        label: "Konten Berita",
        prop: "content",
        rules: {
        required: true,
        message: 'Konten Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: form.value.content,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.content) = $event)),
            rows: "10",
            onBlur: _cache[11] || (_cache[11] = ($event: any) => (form.value.content = form.value.content.trim()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            size: "small",
            class: "btn btn-sm btn-primary my-5",
            type: "primary",
            onClick: convertText
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _hoisted_19
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_el_form_item, {
        prop: "file_source",
        rules: {
        required: true,
        message: 'File berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        label: _withCtx(() => [
          _hoisted_21,
          _hoisted_22
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.file_source.old, (file) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  file
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        src: file,
                        controls: "",
                        muted: "",
                        width: "150",
                        height: "115"
                      }, null, 8, _hoisted_26))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "small",
                      class: "py-0",
                      onClick: ($event: any) => (handlePreview('old', file))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "small",
                      class: "py-0",
                      onClick: ($event: any) => (handleDelete('old', file))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 512), [
                    [_vShow, file]
                  ])
                ])
              ]))
            }), 256)),
            (render_upload.value)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  ref: (_value, _refs) => {
                    _refs['uploadRef'] = _value
                    uploadRef.value = _value
                  },
                  class: "upload-demo",
                  action: actionFileURL,
                  headers: file_upload_header.value,
                  "on-success": setFileUpload,
                  "before-remove": removeFileUpload,
                  "on-remove": cekFileSource,
                  "on-error": errorFileUpload,
                  multiple: true,
                  accept: "video/mp4,video/x-m4v",
                  "on-preview": handlePreview,
                  "list-type": "picture-card"
                }, {
                  file: _withCtx(({ file }) => [
                    _createElementVNode("div", _hoisted_30, [
                      (file.response)
                        ? (_openBlock(), _createElementBlock("video", {
                            key: 0,
                            src: file.response.file,
                            controls: "",
                            muted: "",
                            width: "150",
                            height: "115"
                          }, null, 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_el_progress, {
                        type: "circle",
                        percentage: file.percentage.toFixed(0)
                      }, null, 8, ["percentage"]), [
                        [_vShow, file.percentage < 100]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_el_button, {
                          type: "text",
                          size: "small",
                          class: "py-0",
                          onClick: ($event: any) => (handlePreview('new', file))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "text",
                          size: "small",
                          class: "py-0",
                          onClick: ($event: any) => (handleDelete('new', file))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 512), [
                        [_vShow, file.percentage === 100]
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "button",
                      class: "btn-primary text-white text-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35,
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["headers"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: dialogPreviewFile.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogPreviewFile).value = $event)),
        title: "Preview File Berita",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("video", {
              src: dialogFileUrl.value,
              controls: "",
              width: "550",
              height: "400"
            }, null, 8, _hoisted_38)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})